var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],ref:"Sync",staticClass:"SyncButton",class:{
    'is-disabled': _vm.disabled,
    'is-sync': _vm.localSyncing && !_vm.disabled,
    'is-highlight': _vm.highlight && !_vm.disabled
  },on:{"click":_vm.onClick}},[_c('lm-icon',{attrs:{"icon":_vm.resolveIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }